// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'https://localhost:8000/'
  apiUrl: '/api/',
  assetsPath: 'assets',
  mediaPath: 'assets/media/',
  maintenance: false,
  paypalSandboxSellerClientId:
    'AbtlRZlMZ_ZQtAcKdiV1_pyKQ1iTcwjI5gRvL9uofusD8oj9_9F0GS8o041Z4rh78NBYtzgSZ4ei7ik0',
  paypalDaydicSellerClientId:
    'AcpgWeaKOJpTu1Fwc5Izcfyhv96z6uibqc8HHCwQTWh_agglJ4v2DUK7550HZVRLeRLXQSPCyuIqL0s_',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
